import React from 'react';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';
import '../styles/PolicyPages.css';

const TermsConditions = () => {
    return (
        <div className="policy-page-wrapper">
            <Navbar />
            <main className="policy-simple-container">
                <div className="policy-simple-header">
                    <h1>Terms & Conditions – Prints Carts</h1>
                    <p className="last-updated">Last Updated: January 26, 2026</p>
                </div>

                <div className="policy-simple-content">
                    <div className="intro">
                        Please read these Terms & Conditions carefully. By accessing or using www.printscarts.com (“Website”), you agree to be bound by the terms outlined below. If you do not agree to these Terms & Conditions, you should discontinue use of our website.<br /><br />
                        These Terms govern your use of our website, purchase of products, and any services we provide as an independent online retailer.
                    </div>

                    <section>
                        <h2>1. Company Information</h2>
                        <p>
                        Prints Carts<br />
                        7181 Beacon Dr 15<br />
                        Reno, NV 89506<br />
                        United States<br />
                        Website: www.printscarts.com<br />
                        Email: support@printscarts.com
                        </p>
                        <p>Prints Carts is an independent retailer offering printers, ink, toner, and printing supplies. We are not affiliated with or endorsed by any manufacturer unless explicitly stated. All trademarks belong to their respective owners.</p>
                    </section>

                    <section>
                        <h2>2. Acceptance of Terms</h2>
                        <p>By using our website, placing an order, or contacting us, you acknowledge that:</p>
                        <ul>
                            <li>You have read and understood these Terms</li>
                            <li>You agree to comply with all applicable laws</li>
                            <li>You are at least 18 years of age or have permission from a legal guardian</li>
                        </ul>
                        <p>If you disagree with any part of these Terms, please avoid using the site.</p>
                    </section>

                    <section>
                        <h2>3. Use of Website</h2>
                        <p>You agree to use our website only for lawful purposes. You must not:</p>
                        <ul>
                            <li>Engage in fraudulent activity</li>
                            <li>Interfere with website functionality</li>
                            <li>Attempt unauthorized access</li>
                            <li>Copy or misuse website content</li>
                            <li>Use automated tools (scrapers/bots) without permission</li>
                        </ul>
                        <p>We reserve the right to suspend access for misuse or violation of these Terms.</p>
                    </section>

                    <section>
                        <h2>4. Product Information & Accuracy</h2>
                        <p>We strive to provide accurate product information, including:</p>
                        <ul>
                            <li>Specifications</li>
                            <li>Images</li>
                            <li>Pricing</li>
                            <li>Compatibility</li>
                            <li>Availability</li>
                        </ul>
                        <p>However, product details may be updated by manufacturers without notice.</p>
                        <p>Important notes:</p>
                        <ul>
                            <li>Colors may vary depending on device settings</li>
                            <li>Page yields are estimates based on standardized testing</li>
                            <li>Availability may change due to inventory updates</li>
                            <li>Prices may change without prior notice</li>
                        </ul>
                        <p>Prints Carts is not responsible for unintentional typographical or listing errors.</p>
                    </section>

                    <section>
                        <h2>5. Ordering & Payments</h2>
                        <p>By placing an order, you confirm that:</p>
                        <ul>
                            <li>All information provided is accurate</li>
                            <li>You are authorized to use the selected payment method</li>
                            <li>You understand that orders are subject to acceptance and availability</li>
                        </ul>
                        <p>We may cancel or refuse orders for reasons including:</p>
                        <ul>
                            <li>Incorrect pricing</li>
                            <li>Payment issues</li>
                            <li>Suspected fraud</li>
                            <li>Product unavailability</li>
                        </ul>
                        <p>Payment is required before products are shipped. All transactions are processed securely via trusted payment providers.</p>
                    </section>

                    <section>
                        <h2>6. Shipping & Delivery</h2>
                        <p>Delivery timelines vary based on:</p>
                        <ul>
                            <li>Location</li>
                            <li>Carrier operations</li>
                            <li>Product availability</li>
                            <li>Weather or transit delays</li>
                        </ul>
                        <p>We provide estimated delivery dates during checkout, but these are not guaranteed.</p>
                        <p>Risk of loss transfers to the customer when the order is delivered to the carrier. Please review our Shipping Policy for full details.</p>
                    </section>

                    <section>
                        <h2>7. Returns & Refunds</h2>
                        <p>Returns must follow the guidelines in our Return & Exchange Policy, including:</p>
                        <ul>
                            <li>30-day return window</li>
                            <li>Unused and unopened items in original packaging</li>
                            <li>RMA authorization before sending items back</li>
                        </ul>
                        <p>Refunds are issued after inspection and approval. Customers may be responsible for return shipping depending on the reason for return.</p>
                    </section>

                    <section>
                        <h2>8. Intellectual Property</h2>
                        <p>All content on this website—including text, graphics, logos, images, and layout—is owned by or licensed to Prints Carts and protected by applicable intellectual property laws.</p>
                        <p>You may not:</p>
                        <ul>
                            <li>Copy</li>
                            <li>Modify</li>
                            <li>Distribute</li>
                            <li>Reproduce</li>
                        </ul>
                        <p>any website content without written permission.</p>
                        <p>All third-party trademarks and brand names belong to their respective owners and are used only for identification.</p>
                    </section>

                    <section>
                        <h2>9. Third-Party Links</h2>
                        <p>Our website may include links to third-party sites for information or convenience.</p>
                        <p>Prints Carts is not responsible for:</p>
                        <ul>
                            <li>Content on external sites</li>
                            <li>Privacy practices</li>
                            <li>Security standards</li>
                        </ul>
                        <p>We recommend reviewing third-party terms before interacting with their websites.</p>
                    </section>

                    <section>
                        <h2>10. Limitation of Liability</h2>
                        <p>To the extent permitted by law, Prints Carts is not liable for:</p>
                        <ul>
                            <li>Indirect or incidental damages</li>
                            <li>Loss of data</li>
                            <li>Loss of revenue or profits</li>
                            <li>Issues caused by third-party carriers or service providers</li>
                            <li>Misuse of products after purchase</li>
                        </ul>
                        <p>Our total liability for any claim shall not exceed the amount paid for the product involved.</p>
                    </section>

                    <section>
                        <h2>11. Disclaimer of Warranties</h2>
                        <p>Our website and content are provided on an “as-is” and “as-available” basis. We do not guarantee:</p>
                        <ul>
                            <li>Uninterrupted access</li>
                            <li>Error-free operation</li>
                            <li>Compatibility with all devices</li>
                            <li>Specific performance outcomes</li>
                        </ul>
                        <p>Manufacturer warranties apply to eligible products as provided by their respective brands.</p>
                    </section>

                    <section>
                        <h2>12. Indemnification</h2>
                        <p>You agree to indemnify and hold Prints Carts harmless from claims, damages, or losses arising from:</p>
                        <ul>
                            <li>Misuse of the website</li>
                            <li>Violation of these Terms</li>
                            <li>Unauthorized access or activity</li>
                        </ul>
                    </section>

                    <section>
                        <h2>13. Changes to These Terms</h2>
                        <p>We may update these Terms at any time. Changes take effect immediately when posted on this page. Continuing to use the website means you accept the updated terms.</p>
                    </section>

                    <section>
                        <h2>14. Governing Law</h2>
                        <p>These Terms & Conditions are governed by the laws of the United States. Any disputes will be handled under the jurisdiction of applicable U.S. courts.</p>
                    </section>

                    <section>
                        <h2>15. Contact Us Regarding These Terms</h2>
                        <p>If you have questions about these Terms & Conditions, please reach out:</p>
                        <p>
                            Email: support@printscarts.com<br />
                            Address: 7181 Beacon Dr 15, Reno, NV 89506<br />
                            Website: www.printscarts.com
                        </p>
                    </section>
                </div>

                <div className="policy-document-footer">
                    <span style={{ fontSize: '13px', color: '#94a3b8' }}>Document Reference: PC-TC-2026-V1</span>
                    <button 
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        style={{ background: 'none', border: 'none', color: '#0f3d91', fontWeight: '600', cursor: 'pointer' }}
                    >
                        Back to Top ↑
                    </button>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default TermsConditions;
